import type { SxProps, Theme } from "@mui/material";

/**
 * Strong dropdown surface used across management pages: deep shadow +
 * hairline border so open menus never blend into the page background.
 * Same recipe as the User Management autocomplete dropdowns.
 */
export const STRONG_DROPDOWN_PAPER_SX: SxProps<Theme> = (theme: Theme) => ({
  boxShadow: theme.shadows[12],
  border: "1px solid",
  borderColor: "divider",
});

/** For `Select` / `TextField select` menus: `MenuProps={strongSelectMenuProps}`. */
export const strongSelectMenuProps = {
  PaperProps: { elevation: 0, sx: STRONG_DROPDOWN_PAPER_SX },
} as const;

/** For `Autocomplete`: `componentsProps={strongAutocompletePaperProps}`. */
export const strongAutocompletePaperProps = {
  paper: { elevation: 0, sx: STRONG_DROPDOWN_PAPER_SX },
} as const;
